import { createApiAction } from '@app/packages/api/utils'
import type { ApiQuizGame } from '@app/packages/api/v2/types/entities'

export const getQuizGames = () =>
  createApiAction('getQuizGames', dispatch => dispatch<{ data: ApiQuizGame[] }>({ method: 'GET', endpoint: '/api/v2/quiz/games' }))
